export const SATISFIED_QUESTION = 1;
export const STAR_QUESTION = 2;
export const AGAIN_QUESTION = 3;
